import { TabletIcon, AlertTriangleIcon, SettingsIcon } from 'vue-feather-icons'
import _ from 'lodash'
export default {
  props: {
    cpu: Object,
    cpHeight: Number,
    cpOperationKind: String,
    forcedHeight: Number,
    openedBoxId: String,
    isSelected: Boolean,
    displayIcons: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      multiplayer: 1,
      calculatedWidth: 100, // default values
      calculatedHeight: 150, // default values
      parsedBoxes: [],
      borderWidthBonus: 2
    }
  },
  components: {
    TabletIcon,
    AlertTriangleIcon,
    SettingsIcon
  },
  mounted() {
    this.calculateMultiplayer()
    this.parseBoxes()
  },
  watch: {
    cpu: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.calculateMultiplayer()
        this.parseBoxes()
      }
    }
  },
  computed: {
    cpuStyle: function () {
      let styles = {}
      if (this.cpOperationKind == 'lockers') {
        let maxBoxesInRow = this.findMaxBoxesInRow(this.cpu.boxes).maxBoxesInRow
        let rowsCount = this.findMaxBoxesInRow(this.cpu.boxes).rowsCount
        let boxWidth = _.ceil(this.calculatedHeight / rowsCount, 2) // they are squares

        styles = {
          width: `${maxBoxesInRow * boxWidth + this.borderWidthBonus}px`,
          height: `${this.calculatedHeight}px`,
          background: `${this.isSelected ? '#f0f9f8' : '#f5f5f5'}`,
          border: `${this.isSelected ? '1px solid #67c9bb' : '1px solid #b5b5b5'}`
        }
      } else {
        styles = {
          width: `${this.calculatedWidth}px`,
          height: `${this.calculatedHeight}px`,
          background: `${this.isSelected ? '#f0f9f8' : '#f5f5f5'}`,
          border: `${this.isSelected ? '1px solid #67c9bb' : '1px solid #b5b5b5'}`
        }
      }
      return styles
    }
  },

  methods: {
    calculateMultiplayer() {
      let multiplayer = _.ceil(this.forcedHeight / this.cpHeight, 3) // manipulate this for details
      this.multiplayer = multiplayer
      this.calculatedHeight = this.forcedHeight + this.borderWidthBonus
      this.calculatedWidth = multiplayer * this.cpu.width + this.borderWidthBonus
    },

    parseBoxes() {
      let rawBoxes = this.cpu.boxes
      let cleanBoxes =
        this.cpOperationKind == 'lockers'
          ? this.cleanBoxesGeneratorLockers(rawBoxes)
          : this.cleanBoxesGenerator(rawBoxes)
      console.log('cleanBoxes', cleanBoxes)
      this.parsedBoxes = cleanBoxes
    },

    cleanBoxesGenerator(rawBoxes) {
      return rawBoxes
        .map((box) => {
          if (box.coordinates) {
            let oldCoordinates = box.coordinates.split(',')
            let left = `${_.ceil(oldCoordinates[0] * this.multiplayer, 3)}px`
            let top = `${_.ceil(oldCoordinates[1] * this.multiplayer, 3)}px`
            let width = `${_.ceil(oldCoordinates[2] * this.multiplayer, 3)}px`
            let height = `${_.ceil(oldCoordinates[3] * this.multiplayer, 3)}px`
            let newCoordinates = { top, left, width, height }
            let newBox = Object.assign({}, box, { coordinates: newCoordinates })
            return newBox
          }

          // we must filter [undefined] out...
        })
        .filter((x) => x)
    },

    cleanBoxesGeneratorLockers(rawBoxes) {
      let rowsCount = this.findMaxBoxesInRow(rawBoxes).rowsCount
      let cpuHeight = this.calculatedHeight
      let rowHeight = cpuHeight / rowsCount

      return rawBoxes
        .map((box) => {
          let positions = box.position.split(',')
          if (box.position && this.hasProperPosition(positions)) {
            let row = positions[0]
            let orderFromLeft = positions[1]

            let left = `${_.ceil(row * rowHeight - rowHeight, 3)}px`
            let top = `${_.ceil(orderFromLeft * rowHeight - rowHeight, 3)}px`
            let width = `${_.ceil(rowHeight, 3)}px`
            let height = `${_.ceil(rowHeight, 3)}px`

            let newCoordinates = { top, left, width, height }
            let newBox = Object.assign({}, box, { coordinates: newCoordinates })
            return newBox
          }
        })
        .filter((x) => x)
    },

    hasProperPosition(positions) {
      let left = parseFloat(positions[0])
      let top = parseFloat(positions[1])
      return (left == 0 && top >= 1) || (left >= 1 && top == 0) || (left >= 1 && top >= 1)
    },

    findMaxBoxesInRow: function (boxes) {
      let newBoxes = []

      boxes.forEach((box) => {
        let positions = box.position.split(',')
        let left = parseFloat(positions[0])
        let top = parseFloat(positions[1])
        let newPositions = { top, left }
        let newBox = Object.assign({}, box, { coordinates: newPositions })

        if (this.hasProperPosition(positions)) {
          newBoxes.push(newBox)
        }
      })

      let rowsCount = Object.keys(_.groupBy(newBoxes, 'coordinates.top')).length
      let maxBoxesInRow = _.chain(newBoxes)
        .groupBy('coordinates.top') // {1: Array(4), 2: Array(4), 3: Array(4)}
        .toPairs() // [Array(2), Array(2), Array(2)]
        .map((value) => value[1].length) // [4, 4, 4]
        .max() // 4
        .value()

      let dimesions = {
        maxBoxesInRow,
        rowsCount
      }

      return dimesions
    },

    boxStyle: function (box) {
      let style = {}

      style = {
        top: box.coordinates.top,
        left: box.coordinates.left,
        width: box.coordinates.width,
        height: box.coordinates.height,
        border: `${this.isSelected ? '1px solid #67c9bb' : '1px solid #b5b5b5'}`,
        color: `${this.isSelected ? '#67c9bb' : '#b5b5b5'}`,
        background: `${box.id == this.openedBoxId ? '#67c9bb' : 'none'}`
      }

      // } else { style = { display: 'none' }; }
      return style
    }

    // SPA
    // selectCpu() {
    //   this.$emit('selectCpu', this.cpu.id);
    // }
  }
}
